import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {inject, ref, toRefs} from "vue";
import {SmartSearchConfigInterface} from "@/core/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClearQueryButton',
  props: ['autocomplete'],
  setup(__props) {



const urlStore = useUrlStore()
const queryStore = useSearchQueryStore();
const {hasQuery} = toRefs(queryStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query
const {showButtonOnInput} = SmartSearchConfig.value.serp
const {redirectionUrl} = SmartSearchConfig.value.appConfiguration


return (_ctx: any,_cache: any) => {
  return (_unref(hasQuery))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["autocomplete-search__clear-query-button q-position-absolute q-btn-close q-bg-light q-p-2", { 'q-input-with-button': _unref(showButtonOnInput) }]),
        type: "button",
        title: "Wyczyść",
        "aria-label": "Clear",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(urlStore).clearQuery(_unref(redirectionUrl), __props.autocomplete)), ["prevent"]))
      }, null, 2))
    : _createCommentVNode("", true)
}
}

})